import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserAssignment = (props) => /* @__PURE__ */ _jsxs("svg", {
	name: "user-assignment",
	viewBox: "0 0 280 186",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("filter", {
			x: "-7.5%",
			y: "-1.8%",
			width: "115%",
			height: "103.6%",
			filterUnits: "objectBoundingBox",
			id: "a",
			children: /* @__PURE__ */ _jsx("feGaussianBlur", {
				stdDeviation: 1,
				in: "SourceGraphic"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "b",
			d: "M0 0h24v24H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "d",
			d: "M0 0h24v24H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "f",
			d: "M0 0h24v24H0z"
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				fill: "#FFF",
				opacity: .4,
				y: 8,
				width: 280,
				height: 56,
				rx: 4
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "shadow",
				fillOpacity: .7,
				fill: "#483D9F",
				filter: "url(#a)",
				x: 8,
				y: 16,
				width: 40,
				height: 168,
				rx: 4
			}),
			/* @__PURE__ */ _jsxs("g", {
				className: "slide-up",
				transform: "translate(16)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						width: 40,
						height: 168,
						rx: 4
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(8 24)",
						children: [/* @__PURE__ */ _jsx("mask", {
							id: "c",
							fill: "#fff",
							children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#b" })
						}), /* @__PURE__ */ _jsxs("g", {
							mask: "url(#c)",
							fill: "#5649BE",
							children: [/* @__PURE__ */ _jsx("path", { d: "M12 12c1.455 0 2.696-.51 3.725-1.528 1.03-1.018 1.544-2.247 1.544-3.686 0-1.44-.514-2.668-1.544-3.687-1.029-1.018-2.27-1.528-3.725-1.528s-2.697.51-3.726 1.528C7.245 4.118 6.731 5.346 6.731 6.786s.514 2.668 1.543 3.686C9.304 11.491 10.545 12 12 12z" }), /* @__PURE__ */ _jsx("path", { d: "M21.42 16.026a11.4 11.4 0 0 0-.364-1.473 6.941 6.941 0 0 0-.59-1.324 4.776 4.776 0 0 0-.851-1.1 3.585 3.585 0 0 0-1.173-.726 4.162 4.162 0 0 0-1.53-.272c-.083 0-.275.097-.577.292-.301.194-.642.412-1.022.652-.38.24-.874.457-1.482.651a5.98 5.98 0 0 1-1.832.292 5.98 5.98 0 0 1-1.831-.292c-.609-.194-1.103-.412-1.482-.651-.38-.24-.72-.457-1.023-.652-.301-.195-.493-.292-.576-.292a4.16 4.16 0 0 0-1.53.271 3.585 3.585 0 0 0-1.173.727 4.78 4.78 0 0 0-.85 1.1c-.248.43-.444.871-.59 1.324-.147.452-.268.943-.364 1.473-.096.53-.16 1.023-.192 1.48-.032.457-.048.926-.048 1.406 0 1.086.334 1.944 1.001 2.573.668.629 1.556.943 2.662.943h11.993c1.107 0 1.994-.314 2.662-.943.668-.63 1.002-1.487 1.002-2.573 0-.48-.016-.949-.048-1.406-.032-.457-.096-.95-.192-1.48z" })]
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(8 120)",
						opacity: .4,
						children: [/* @__PURE__ */ _jsx("mask", {
							id: "e",
							fill: "#fff",
							children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#d" })
						}), /* @__PURE__ */ _jsxs("g", {
							mask: "url(#e)",
							fill: "#5649BE",
							children: [/* @__PURE__ */ _jsx("path", { d: "M12 12c1.455 0 2.696-.51 3.725-1.528 1.03-1.018 1.544-2.247 1.544-3.686 0-1.44-.514-2.668-1.544-3.687-1.029-1.018-2.27-1.528-3.725-1.528s-2.697.51-3.726 1.528C7.245 4.118 6.731 5.346 6.731 6.786s.514 2.668 1.543 3.686C9.304 11.491 10.545 12 12 12z" }), /* @__PURE__ */ _jsx("path", { d: "M21.42 16.026a11.4 11.4 0 0 0-.364-1.473 6.941 6.941 0 0 0-.59-1.324 4.776 4.776 0 0 0-.851-1.1 3.585 3.585 0 0 0-1.173-.726 4.162 4.162 0 0 0-1.53-.272c-.083 0-.275.097-.577.292-.301.194-.642.412-1.022.652-.38.24-.874.457-1.482.651a5.98 5.98 0 0 1-1.832.292 5.98 5.98 0 0 1-1.831-.292c-.609-.194-1.103-.412-1.482-.651-.38-.24-.72-.457-1.023-.652-.301-.195-.493-.292-.576-.292a4.16 4.16 0 0 0-1.53.271 3.585 3.585 0 0 0-1.173.727 4.78 4.78 0 0 0-.85 1.1c-.248.43-.444.871-.59 1.324-.147.452-.268.943-.364 1.473-.096.53-.16 1.023-.192 1.48-.032.457-.048.926-.048 1.406 0 1.086.334 1.944 1.001 2.573.668.629 1.556.943 2.662.943h11.993c1.107 0 1.994-.314 2.662-.943.668-.63 1.002-1.487 1.002-2.573 0-.48-.016-.949-.048-1.406-.032-.457-.096-.95-.192-1.48z" })]
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(8 72)",
						opacity: .4,
						children: [/* @__PURE__ */ _jsx("mask", {
							id: "g",
							fill: "#fff",
							children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#f" })
						}), /* @__PURE__ */ _jsxs("g", {
							mask: "url(#g)",
							fill: "#5649BE",
							children: [/* @__PURE__ */ _jsx("path", { d: "M12 12c1.455 0 2.696-.51 3.725-1.528 1.03-1.018 1.544-2.247 1.544-3.686 0-1.44-.514-2.668-1.544-3.687-1.029-1.018-2.27-1.528-3.725-1.528s-2.697.51-3.726 1.528C7.245 4.118 6.731 5.346 6.731 6.786s.514 2.668 1.543 3.686C9.304 11.491 10.545 12 12 12z" }), /* @__PURE__ */ _jsx("path", { d: "M21.42 16.026a11.4 11.4 0 0 0-.364-1.473 6.941 6.941 0 0 0-.59-1.324 4.776 4.776 0 0 0-.851-1.1 3.585 3.585 0 0 0-1.173-.726 4.162 4.162 0 0 0-1.53-.272c-.083 0-.275.097-.577.292-.301.194-.642.412-1.022.652-.38.24-.874.457-1.482.651a5.98 5.98 0 0 1-1.832.292 5.98 5.98 0 0 1-1.831-.292c-.609-.194-1.103-.412-1.482-.651-.38-.24-.72-.457-1.023-.652-.301-.195-.493-.292-.576-.292a4.16 4.16 0 0 0-1.53.271 3.585 3.585 0 0 0-1.173.727 4.78 4.78 0 0 0-.85 1.1c-.248.43-.444.871-.59 1.324-.147.452-.268.943-.364 1.473-.096.53-.16 1.023-.192 1.48-.032.457-.048.926-.048 1.406 0 1.086.334 1.944 1.001 2.573.668.629 1.556.943 2.662.943h11.993c1.107 0 1.994-.314 2.662-.943.668-.63 1.002-1.487 1.002-2.573 0-.48-.016-.949-.048-1.406-.032-.457-.096-.95-.192-1.48z" })]
						})]
					})
				]
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(64 26)",
				fill: "#FFF",
				opacity: .4,
				children: [/* @__PURE__ */ _jsx("rect", {
					width: 192,
					height: 8,
					rx: 1
				}), /* @__PURE__ */ _jsx("rect", {
					y: 12,
					width: 118,
					height: 8,
					rx: 1
				})]
			})
		]
	})]
});
export default SvgUserAssignment;
